import script from "./keyMetrics.vue?vue&type=script&setup=true&lang=js"
export * from "./keyMetrics.vue?vue&type=script&setup=true&lang=js"

import "./keyMetrics.vue?vue&type=style&index=0&id=f3dbebc6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3dbebc6"]])

export default __exports__